import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import AA from './Pages/AA/AA.js';

function App() {
	return (
		<>
			<Router>
				<div>
					{/* <nav>
						<ul>
							<li>
								<a href="https://hoangluu404.web.app">Previous</a>
							</li>
						</ul>
					</nav> */}

					<Switch>
						<Route path="/">
							<AA />
						</Route>
					</Switch>
				</div>
			</Router>
		</>
	);
}

export default App;
